<template>
  <div class="content-historic-request">
    <h2>Histórico de pedidos</h2>
    <div class="item">
      <table>
        <tr v-for="i in data.list" v-bind:key="i.id">
          <td style="min-width: 65px; width: 65px"><strong><router-link :to="{name: 'OrderValidation', params: { txid: i.uuid }}" target="_blank">#{{ i.id | numeral('00000') }}</router-link></strong></td>
          <td class="text-truncate">{{ i.dateCreated | moment }} {{ i.dateCreated | moment-hour }}</td>
          <td class="text-truncate">{{ i.seller }}</td>
          <td style="min-width: 120px; width: 120px"><span :class="(i.currentStep === 'Aprovado' || i.currentStep === 'Aprovado - Pagamentos Pendentes') ? 'success' : ((i.currentStep === 'Rejeitado' || i.currentStep === 'Cancelado') ? 'danger' : 'warning')">{{ i.currentStep.substring(0, 12) }}</span></td>
        </tr>
      </table>
    </div>
    <div class="aling-button">
      <button class="btn-load-more" @click="handleLoadMore" v-if="data.list.length >= 5">{{ loading ? 'Carregando' : 'Carregar mais' }}</button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      data: [],
      more: 5,
      loading: false
    }
  },
  mounted () {
    this.getCustomerOrderHistory()
  },
  methods: {
    getCustomerOrderHistory () {
      this.loading = true
      this.$http.get('api/order-validation/' + this.$route.params.txid + '/customer-order-history', {
        params: {
          max: this.more
        }
      })
        .then(function (res) {
          this.data = res.data
          this.loading = false
        })
        .catch(function (res) {
          console.log('Error')
          console.log(res)
          this.loading = false
        })
    },
    handleLoadMore () {
      this.more += 5
      this.getCustomerOrderHistory()
    }
  }
}
</script>

<style lang="scss" scoped>
.content-historic-request {
  table {
    margin: 0;
    padding: 0;
    display: flow-root;
    overflow: hidden;
    tr {
      list-style: none;
      margin: 0;
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
      border-bottom: solid 1px #e5e5e5;
      td {
        display: inline-block;
        padding: 5px;
        width: 25%;
        span {
          padding: 2px 10px;
          border-radius: 4px;
        }
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
.aling-button {
  display: flex;
  justify-content: center;
  .btn-load-more {
    outline: transparent;
    background-color: transparent;
    border: 1px solid transparent;
    font-weight: bold;
    color: #4285F4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partial/customer/OrderHistoric.vue